import { h, JSX } from "preact"
import { classJoin } from "../helpers/classjoin"
import { SliderMarks } from "./AbstractSlider"

/**
 * @group Components
 */
export interface MarksProps {
    min: number
    max: number
    lowerBound: number
    upperBound: number
    marks: SliderMarks
    included: boolean
    vertical: boolean
    classesPrefix: string
}

/**
 * Marks on the slider.
 *
 * @group Components
 */
export function Marks({ min, max, lowerBound, upperBound, marks, included, vertical, classesPrefix }: MarksProps) {
    const marksKeys = Object.keys(marks)
    const marksCount = marksKeys.length
    const unit = 100 / (marksCount - 1)
    const markWidth = unit * 0.9

    const range = max - min

    const elements = marksKeys
        .map(Number)
        .sort((a, b) => a - b)
        .map(point => {
            const active =
                (!included && point === upperBound) || (included && point <= upperBound && point >= lowerBound)

            const classes = classJoin(
                {
                    active,
                    text: true
                },
                cl => `${classesPrefix}${cl}`
            )

            const style: JSX.CSSProperties = vertical
                ? {
                      marginBottom: "-50%",
                      bottom: `${((point - min) / range) * 100}%`
                  }
                : {
                      width: `${markWidth}%`,
                      marginLeft: `${-markWidth / 2}%`,
                      left: `${((point - min) / range) * 100}%`
                  }

            const markPoint = marks[point]

            return (
                <span class={classes} style={style} key={String(point)}>
                    {markPoint}
                </span>
            )
        })

    return <div class={`${classesPrefix}marks`}>{elements}</div>
}
